import { MenuItem, Select } from '@mui/material';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import type { IconType, StyleObj } from '../../@types';
import { ICON_GROUP } from '../../constants/enums';
import { getIconNamesByType } from '../../constants/icons';
import IconRenderer from '../atoms/IconRenderer';

const styles: StyleObj = {
  select: {
    height: 48,
    width: 80,
    '& .MuiSelect-select > img': {
      pt: '6px',
    },
  },
  menu: {
    '& .MuiPaper-root': {
      maxHeight: 300,
    },
  },
};

type Props<T extends FieldValues, TTransformedValues extends FieldValues | undefined = T> = {
  control: Control<T, unknown, TTransformedValues>;
  name: Path<T>;
  iconType?: IconType;
};

const IconSelect = <T extends FieldValues, TTransformedValues extends FieldValues | undefined = T>({
  control,
  name,
  iconType = ICON_GROUP.SPORTS,
}: Props<T, TTransformedValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Select
          sx={styles.select}
          MenuProps={{
            sx: styles.menu,
          }}
          {...field}
        >
          {getIconNamesByType(iconType).map((name) => (
            <MenuItem key={name} value={name}>
              <IconRenderer name={name} type={iconType} />
            </MenuItem>
          ))}
        </Select>
      )}
    />
  );
};

export default IconSelect;
